<div class="one" fxLayout="column" [formGroup]="MatterConveyancingDetailsForm">
  <div fxLayout="row" class="checkbox-row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <mat-checkbox class="checkbox-width" formControlName="OFFTHEPLAN">Off the Plan</mat-checkbox>
    <mat-checkbox class="checkbox-width" formControlName="CONTRACTRECINDED">
      Contract Rescinded
    </mat-checkbox>
    <mat-checkbox class="checkbox-width" formControlName="OCCUPANCYCERTIFICATEISSUED">
      Occupancy Cert. issued.
    </mat-checkbox>
  </div>
  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <mat-form-field appearance="outline" fxFlex="33" class="pr-1">
      <mat-label>Sunset Date</mat-label>
      <input
        (dateInput)="CommanDatePickerClick('input', $event, 'SUNSETDATE')"
        formControlName="SUNSETDATETEXT"
        (dateChange)="CommanDatePickerClick('input', $event, 'SUNSETDATE')"
        matInput
        name="SunsetDate"
        [matDatepicker]="SunsetDate"
      />
      <mat-datepicker-toggle matSuffix [for]="SunsetDate"></mat-datepicker-toggle>
      <mat-datepicker #SunsetDate></mat-datepicker>
    </mat-form-field>
    <mat-form-field appearance="outline" fxFlex="34" class="pr-1">
      <mat-label>Sunset Extension Date</mat-label>
      <input
        (dateInput)="CommanDatePickerClick('input', $event, 'SUNSETEXTENSIONDATE')"
        formControlName="SUNSETEXTENSIONDATETEXT"
        (dateChange)="CommanDatePickerClick('input', $event, 'SUNSETEXTENSIONDATE')"
        matInput
        name="SunsetExtensionDate"
        [matDatepicker]="SunsetExtensionDate"
      />
      <mat-datepicker-toggle matSuffix [for]="SunsetExtensionDate"></mat-datepicker-toggle>
      <mat-datepicker #SunsetExtensionDate></mat-datepicker>
    </mat-form-field>
    <mat-form-field appearance="outline" fxFlex="33" class="pr-1">
      <mat-label>Registration</mat-label>
      <input
        (dateInput)="CommanDatePickerClick('input', $event, 'REGISTRATIONDATE')"
        formControlName="REGISTRATIONDATETEXT"
        (dateChange)="CommanDatePickerClick('input', $event, 'REGISTRATIONDATE')"
        matInput
        name="RegistrationDate"
        [matDatepicker]="RegistrationDate"
      />
      <mat-datepicker-toggle matSuffix [for]="RegistrationDate"></mat-datepicker-toggle>
      <mat-datepicker #RegistrationDate></mat-datepicker>
    </mat-form-field>
  </div>
  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <mat-form-field appearance="outline" fxFlex="34" class="pr-1">
      <mat-label>Recission Date</mat-label>
      <input
        (dateInput)="CommanDatePickerClick('input', $event, 'CONTRACTRECISSIONDATE')"
        formControlName="CONTRACTRECISSIONDATETEXT"
        (dateChange)="CommanDatePickerClick('input', $event, 'CONTRACTRECISSIONDATE')"
        matInput
        name="RecissionDate"
        [matDatepicker]="RecissionDate"
      />
      <mat-datepicker-toggle matSuffix [for]="RecissionDate"></mat-datepicker-toggle>
      <mat-datepicker #RecissionDate></mat-datepicker>
    </mat-form-field>
    <mat-form-field appearance="outline" fxFlex="40" class="pr-1">
      <mat-label>Date Occupancy Cert. issued.</mat-label>
      <input
        (dateInput)="CommanDatePickerClick('input', $event, 'OCCUPANCYCERTIFICATEISSUEDDATE')"
        formControlName="OCCUPANCYCERTIFICATEISSUEDDATETEXT"
        (dateChange)="CommanDatePickerClick('input', $event, 'OCCUPANCYCERTIFICATEISSUEDDATE')"
        matInput
        name="DateOccupancy"
        [matDatepicker]="DateOccupancy"
      />
      <mat-datepicker-toggle matSuffix [for]="DateOccupancy"></mat-datepicker-toggle>
      <mat-datepicker #DateOccupancy></mat-datepicker>
    </mat-form-field>
  </div>
</div>
